import React from 'react';
import { useDispatch } from 'react-redux';
import { PapiGallection } from '@wix/da-papi-types';
import { useMMDispatch } from '../../_hocs/withOwnReduxStore';
import { useTranslation } from 'react-i18next';
import StandardMenu from '@wix/da-ds/pkg/Dropdown/MenuPreset/StandardMenu';
import { labelAs } from '../../actions';
import { addNotification } from '../../../Notifications/redux/actionCreators';
import { NotificationType } from '../../types';

interface Props {
  className?: string;
  gallection?: PapiGallection;
  deviationIds?: number[];
}

const LabelAsMenu: React.FC<Props> = ({
  className,
  gallection,
  deviationIds,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dispatchMM = useMMDispatch();

  return (
    <StandardMenu
      id="gallection-list-menu"
      lightText
      className={className}
      items={[
        {
          items: [
            {
              label: t('mediapopup.labelAs.menu.createdWithAI'),
              onClick: () => {
                dispatchMM(
                  labelAs({
                    gallection,
                    deviationIds,
                    attribute: 'ai_generated',
                    value: true,
                  })
                );
                dispatch(
                  addNotification(NotificationType.LABEL_AS, {
                    folderName: gallection?.name,
                    deviationIds,
                    label: 'aiGenerated',
                    value: true,
                  })
                );
              },
            },
            {
              label: t('mediapopup.labelAs.menu.createdWithoutAI'),
              onClick: () => {
                dispatchMM(
                  labelAs({
                    gallection,
                    deviationIds,
                    attribute: 'ai_generated',
                    value: false,
                  })
                );
                dispatch(
                  addNotification(NotificationType.LABEL_AS, {
                    folderName: gallection?.name,
                    deviationIds,
                    label: 'aiGenerated',
                    value: false,
                  })
                );
              },
            },
          ],
        },
        {
          items: [
            {
              label: t('mediapopup.labelAs.menu.addNoAiLabel'),
              onClick: () => {
                dispatchMM(
                  labelAs({
                    gallection,
                    deviationIds,
                    attribute: 'allow_in_ai_datasets',
                    value: false,
                  })
                );
                dispatch(
                  addNotification(NotificationType.LABEL_AS, {
                    folderName: gallection?.name,
                    deviationIds,
                    label: 'noAi',
                    value: true,
                  })
                );
              },
            },
            {
              label: t('mediapopup.labelAs.menu.removeNoAiLabel'),
              onClick: () => {
                dispatchMM(
                  labelAs({
                    gallection,
                    deviationIds,
                    attribute: 'allow_in_ai_datasets',
                    value: true,
                  })
                );
                dispatch(
                  addNotification(NotificationType.LABEL_AS, {
                    folderName: gallection?.name,
                    deviationIds,
                    label: 'noAi',
                    value: false,
                  })
                );
              },
            },
          ],
        },
      ]}
    />
  );
};
LabelAsMenu.displayName = 'LabelAsMenu';

export default LabelAsMenu;
